export default "__VITE_ASSET__7FKeZ5v8__"